import { forceArray } from './forceArray'

export const filterNodes = <T extends any>(
  query: string,
  data: T[],
  selector: (input: T) => string | string[],
) => {
  let filteredNodes: T[] = [];
  const queryLowerCase = query.toLowerCase();
  const searchable = data.map(v => forceArray(selector(v)));
  searchable.forEach((searchable, index) => {
    if (searchable.filter(Boolean).some(v => v.toLowerCase().indexOf(queryLowerCase) > -1)) {
      filteredNodes.push(data[index]);
    }
  });
  return filteredNodes;
}